export default interface ILog {
    eventId: number;
    message: string;
    identifier: string;
    dataString1: string;
    dataString2: string;
    dataString3: string;
    dataNumeric1: number;
    dataNumeric2: number;
    dataNumeric3: number;
    url: string;
    passportId: number;
    customerNumber: number;
    ipAddress: string;
}

export function newLog(): ILog {
    const result: ILog = {
        eventId: 0,
        customerNumber: 0,
        passportId: 0,
        url: '',
        ipAddress: '',
        identifier: '',
        message: '',
        dataNumeric1: 0,
        dataNumeric2: 0,
        dataNumeric3: 0,
        dataString1: '',
        dataString2: '',
        dataString3: ''
    };
    return result;
}
